/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import {
  doPost,
  doPut,
  doGet,
  trataMensagemSucesso,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import FiltroPesquisaOperacoesGet from './FiltroPesquisaOperacoesGet';
import './css/ConsultaOperacoesGet.css';
import { manterApenasFiltro } from '../../utils/helpers';
import RelatorioOperacoesGet from './exportacao-csv/RelatorioOperacoesGet';
import ModalRetornoOperacoesGet from './ModalRetornoOperacoesGet';
import ModalRetornoIntegracaoGet from './ModalRetornoIntegracaoGet';
import ModalAlerta from '../requerimentos/ModalAlerta';
import { msgSubmeterReprocessamentoGet } from '../../utils/constants';

class ConsultaOperacoesGet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      filtrosConsulta: {},
      showDadosRetornoModal: false,
      showDadosRetornoGetModal: false,
      showModalAlerta: false,
      idOperacoesGet: null,
      papelUsuarioLogado: null,
      protocoloTarefaGet: null,
      conteudoModalIntegracaoGet: {
        idTarefaGet: null,
        dataCriacao: null,
        nomeServico: null,
        statusTarefa: null,
        sigla: null,
      },
    };
  }

  componentDidMount() {
    manterApenasFiltro('');
    this.definePapelFiltro();
  }

  /**
   * Busca as informações do registro de operação na situação atual GET
   */
  addLinkIdTarefaGet = (valor, row) => (
    <React.Fragment>
      {valor !== undefined ?
    (<a href="#" onClick={() => this.buscaDetalhesDataIntegracaoGet(row.idTarefaGet)}>{valor}</a>) : (valor)}
    </React.Fragment>
  )
  /**
   * Papéis habilitados a acessar as informações da tabela das operações GET
   */
  definePapelFiltro = () => {
    let retorno = '';
    const isRgps = this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'consultar-compensacao-rgps']);
    const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);
    const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);

    if (isRgps) {
      retorno = 'analista-rgps';
    }
    if (isAnalistaDtp) {
      retorno = 'analista-dtp';
    }
    if (isAnalistaDcomp) {
      retorno = 'analista-rgps';
    }

    this.setState({
      papelUsuarioLogado: retorno,
    });
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtrosConsulta = {};
    if (filtrosPesquisa) {
      filtrosConsulta = this.montaFiltros(filtrosPesquisa);
    }
    this.setState({ ...this.state, filtrosConsulta, filtrosAtuais: filtrosPesquisa }, this.executaConsulta);
  }

  defineNivelFiltro = () => {
    if (this.state.filtrosConsulta.aps) {
      return 3;
    } else if (this.state.filtrosConsulta.gex) {
      return 2;
    } else if (this.state.filtrosConsulta.superintendencia) {
      return 1;
    }
    return 0;
  }
  definirValorUo = (nivel) => {
    if (nivel === 3) {
      return this.state.filtrosConsulta.aps;
    } else if (nivel === 2) {
      return this.state.filtrosConsulta.gex;
    } else if (nivel === 1) {
      return this.state.filtrosConsulta.superintendencia;
    }
    return 0;
  }
  converterValoresParaTipoNumerico = (valor) => {
    let retorno = null;
    if (valor) {
      retorno = Number(valor);
    }
    return retorno;
  }
  validar = (valor) => {
    let retorno = null;
    if (valor) {
      retorno = Number(valor);
    }
    return retorno;
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      const nivel = this.defineNivelFiltro();
      const parametros = {
        'start-position': primeiroItem,
        'max-results': resultadosPorPagina,
      };

      if (this.state.filtrosConsulta.protocoloComprev) {
        parametros.protocoloComprev = this.state.filtrosConsulta.protocoloComprev;
      }
      if (this.state.filtrosConsulta.protocoloTarefaGet) {
        parametros.protocoloTarefaGet = this.converterValoresParaTipoNumerico(this.state.filtrosConsulta.protocoloTarefaGet);
      }
      if (this.state.filtrosConsulta.cpf) {
        parametros.cpf = this.state.filtrosConsulta.cpf;
      }
      if (this.state.filtrosConsulta.mensagem) {
        parametros.mensagem = this.state.filtrosConsulta.mensagem;
      }
      if (this.state.filtrosConsulta.status) {
        parametros.status = this.converterValoresParaTipoNumerico(this.state.filtrosConsulta.status);
      }
      if (nivel !== 0) {
        parametros.nivelUo = nivel;
      }
      if (nivel !== 0) {
        parametros.idUo = this.definirValorUo(nivel);
      }
      doPost(
        'operacoes-get',
        parametros,
        this.tratarSucesso,
        this.tratarErro,
      );
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }
  undefinedToVazio = (valor) => {
    const retorno = '';
    if (valor === undefined) {
      return retorno;
    }
    return valor;
  }
  montaFiltros = (atributosPesquisa) => {
    let atributos = {};
    atributos = { ...atributos };

    if (atributosPesquisa.protocoloComprev) {
      const valor = this.undefinedToVazio(atributosPesquisa.protocoloComprev);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, protocoloComprev: valor };
      } else {
        valorFinal = atributosPesquisa.protocoloComprev.trim();
        atributos = { ...atributos, protocoloComprev: valorFinal };
      }
    }
    if (atributosPesquisa.protocoloTarefaGet) {
      const valor = this.undefinedToVazio(atributosPesquisa.protocoloTarefaGet);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, protocoloTarefaGet: valor };
      } else {
        valorFinal = atributosPesquisa.protocoloTarefaGet.trim();
        atributos = { ...atributos, protocoloTarefaGet: valorFinal };
      }
    }
    if (atributosPesquisa.cpf) {
      const valor = this.undefinedToVazio(atributosPesquisa.cpf);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, cpf: valor };
      } else {
        valorFinal = atributosPesquisa.cpf.trim();
        atributos = { ...atributos, cpf: valorFinal };
      }
    }
    if (atributosPesquisa.mensagem) {
      const valor = this.undefinedToVazio(atributosPesquisa.mensagem);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, mensagem: valor };
      } else {
        valorFinal = atributosPesquisa.mensagem.trim();
        atributos = { ...atributos, mensagem: valorFinal };
      }
    }
    if (atributosPesquisa.status) {
      const valor = this.undefinedToVazio(atributosPesquisa.status);
      let valorFinal = '';
      if (valor === '') {
        atributos = { ...atributos, status: valor };
      } else {
        valorFinal = atributosPesquisa.status.trim();
        atributos = { ...atributos, status: valorFinal };
      }
    }
    if (atributosPesquisa.superintendencia) {
      atributos = { ...atributos, superintendencia: atributosPesquisa.superintendencia };
    }
    if (atributosPesquisa.gex) {
      atributos = { ...atributos, gex: atributosPesquisa.gex };
    }
    if (atributosPesquisa.aps) {
      atributos = { ...atributos, aps: atributosPesquisa.aps };
    }

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };
    return atributos;
  }

  tratarSucessoIdTarefaGetEnvio = (response) => {
    if (response.data === '') {
      this.setState({
        dataCriacao: null,
        nomeServico: null,
        statusTarefa: null,
        sigla: null,
      });
    } else {
      const { conteudoModalIntegracaoGet } = { ...this.state };
      conteudoModalIntegracaoGet.dataCriacao = response.data.dataCriacao;
      conteudoModalIntegracaoGet.nomeServico = response.data.nomeServico;
      conteudoModalIntegracaoGet.statusTarefa = response.data.status;
      conteudoModalIntegracaoGet.sigla = response.data.sigla;
      this.setState({
        showNoContent: false,
        conteudoModalIntegracaoGet,
      }, this.handleModalDadosGetRetorno('showDadosRetornoGetModal'));
    }
  };
  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  showDadosRetornoModal = (row) => {
    this.setState({
      showDadosRetornoModal: !this.state.showDadosRetornoModal,
      retorno: row,
    });
  }
  showDadosRetornoGetModal = (row) => {
    this.setState({
      showDadosRetornoGetModal: !this.state.showDadosRetornoGetModal,
      retorno: row,
    });
  }

  handleModalDadosRetorno = () => {
    this.setState({
      showDadosRetornoModal: !this.state.showDadosRetornoModal,
    });
  }
  handleModalDadosGetRetorno = () => {
    this.setState({
      showDadosRetornoGetModal: !this.state.showDadosRetornoGetModal,
    });
  }
  handleModalStatusGetRetorno = () => {
    this.setState({
      showStatusRetornoGetModal: !this.state.showStatusRetornoGetModal,
    });
  }
  addDataEnvioLabel = (data) => {
    let valor = '';
    if (data) {
      valor = moment(data).format('DD/MM/YYYY HH:mm:ss');
    }
    return valor;
  }
    colunasDefault = [
      {
        id: 'idProtocolo',
        label: 'Protocolo Comprev',
      }, {
        id: 'idTarefaGet',
        label: 'Protocolo Tarefa GET',
        dataFormat: this.addLinkIdTarefaGet,
      }, {
        id: 'dataEnvio',
        label: 'Data de Envio',
        dataFormat: this.addDataEnvioLabel,
      }, {
        id: 'status',
        label: 'Status Operação',
      }];
  addDataEnvioLabel = (data) => {
    let valor = '';
    if (data) {
      valor = moment(data).format('DD/MM/YYYY HH:mm:ss');
    }
    return valor;
  }
  montaColunas = () => {
    const operacoesGetTableHeader = this.colunasDefault.slice();
    let colunasEspecificas = [];
    if (colunasEspecificas) {
      colunasEspecificas = colunasEspecificas.concat(operacoesGetTableHeader);
    }
    colunasEspecificas.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return colunasEspecificas;
  }
  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }
  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }
  trataErrosResponse = (error) => {
    if (error && error.data) {
      const { data } = { ...error };
      this.setState({
        chaveConfirmacao: data.chaveConfirmacao,
        alertas: data.alertas,
        showModalAlerta: !this.state.showModalAlerta,
      });
    }
  }

  trataSucessoResponseEnvio = () => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = 0;
    this.setState({
      showModalAlerta: !this.state.showModalAlerta,
      estadoTabela,
    });
    const mensagemSucesso = ['Operação Adicionada com Sucesso à Lista de Reprocessamento do GET.'];
    trataMensagemSucesso([mensagemSucesso]);
    this.realizaConsulta();
  }
  /**
   * Trata envio dos dados
   */
  confirmSendData = () => {
    const { idOperacoesGet } = { ...this.state };
    const url = `operacoes-get/${idOperacoesGet}`;
    this.setState(() => this.handleSave(url));
  }
  /**
   * Trata as acoes dos botao Salvar
   */
  handleSave = (url) => {
    const { idOperacoesGet } = { ...this.state };
    doPut(
      url,
      idOperacoesGet,
      this.trataSucessoResponseEnvio,
      this.trataErrosResponse,
    );
  }
  /**
   * Trata o envio de parametros para a consulta de integracao GET
   */
  buscaDetalhesDataIntegracaoGet = (valor) => {
    const { conteudoModalIntegracaoGet } = { ...this.state };
    conteudoModalIntegracaoGet.idTarefaGet = valor;
    const url = `integracao-get/${valor}`;
    doGet(
      url,
      this.tratarSucessoIdTarefaGetEnvio,
      this.tratarErro,
      valor,
    );
  }
  submeterOperacaoGet = (row) => {
    this.setState({
      idOperacoesGet: row.idOperacoesGet,
      alertas: [msgSubmeterReprocessamentoGet],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }
  montaAcoes = (row) => {
    const acaoDetalharOperacaoGet = true;
    const acaoSubmeterOperacaoGet = (row.codigoStatus === 3);
    const botaoSubmeterOperacaoGet = acaoSubmeterOperacaoGet ? (
      <Button
        hint="Enviar o Registro da Operação para o Reprocessamento no GET"
        icon="ico-traffic-light"
        mini
        onClick={() => this.submeterOperacaoGet(row)}
      />
    ) : '';
    const botaoDetalharOperacaoGet = acaoDetalharOperacaoGet ? (
      <Button
        hint="Detalhar o Registro da Operação"
        icon="ico-doc-magnifier"
        mini
        onClick={() => this.showDadosRetornoModal(row)}
      />
    ) : '';

    return (
      <React.Fragment>
        <div>
          {botaoDetalharOperacaoGet}
          {botaoSubmeterOperacaoGet}
        </div>
      </React.Fragment>
    );
  }
  createActionColumn = (cell, row) => (
    this.montaAcoes(row)
  )
  montarLegendaNomeRelatorioPorFiltroSelecionado = () => {
    let textoFinal = '';
    const titulo = 'Registro de Operações GET filtrado em ';
    const dataAtual = `${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`;
    textoFinal = `${titulo} ${this.exibirComplementoPorNivelSuperintendencia()} ${dataAtual}`;
    return textoFinal;
  }
  exibirComplementoPorNivelSuperintendencia = () => {
    const nivel = this.defineNivelFiltro();
    let retorno = '';
    let nome = '';
    switch (nivel) {
      case 1:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaSuperintendencias, this.state.filtrosConsulta.superintendencia);
        retorno = `SUPERINTENDÊNCIA: ${this.state.filtrosConsulta.superintendencia} - ${nome}`;
        break;
      case 2:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaGexs, this.state.filtrosEscolhidos.gex);
        retorno = `GEX: ${this.state.filtrosEscolhidos.gex} - ${nome}`;
        break;
      case 3:
        nome = this.recuperarTituloPorId(this.state.filtrosAtuais.listaAps, this.state.filtrosEscolhidos.aps);
        retorno = `APS: ${this.state.filtrosEscolhidos.aps} - ${nome}`;
        break;
      default:
        break;
    }
    return retorno.toUpperCase();
  }
  recuperarTituloPorId = (lista, id) => {
    let retorno = '';
    const index = lista.findIndex(item => (item.value === id));
    if (index !== -1) {
      retorno = lista[index].label;
    }
    return retorno;
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  render() {
    const options = {
      noDataText: 'Nenhum elemento de Operação do Get a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const operacoesGetTableHeader = this.montaColunas();
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmSendData}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroPesquisaOperacoesGet
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            list={this.state.listaRegistrosIndexada}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
          />
          {((this.state.listaRegistrosIndexada) && (this.state.listaRegistrosIndexada.length > 0)) ?
            <RelatorioOperacoesGet
              filtrosConsulta={this.state.filtrosConsulta}
              papelUsuarioLogado={this.state.papelUsuarioLogado}
              converterValoresParaTipoNumerico={this.converterValoresParaTipoNumerico}
              defineNivelFiltro={this.defineNivelFiltro}
              definirValorUo={this.definirValorUo}
            />
          : '' }
          <Table
            //  legend={this.montarLegendaNomeRelatorioPorFiltroSelecionado()}
            style={{ color: '#00314d' }}
            legend={this.state.estadoTabela.quantidadeTotalResultados === 0 ?
              'Consulta Operações de Envio de Registros ao GET' :
              `Consulta Operações de Envios de Registros ao GET -  ${this.state.estadoTabela.quantidadeTotalResultados} registro(s) encontrado(s)`}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={operacoesGetTableHeader}
            pagination
            remote
          />
          {this.state.showDadosRetornoModal ? (
            <ModalRetornoOperacoesGet
              {...this.props}
              estadoFormulario={this.state}
              handleModal={() => this.handleModalDadosRetorno('showDadosRetornoModal')}
              showModal={this.state.showDadosRetornoModal}
            />
          ) : ''}
          {this.state.showDadosRetornoGetModal ? (
            <ModalRetornoIntegracaoGet
              {...this.props}
              estadoFormulario={this.state}
              handleModal={() => this.handleModalDadosGetRetorno('showDadosRetornoGetModal')}
              showModal={this.state.showDadosRetornoGetModal}
            />
          ) : ''}
          {modalAlerta}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaOperacoesGet.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      idProtocolo: PropTypes.string,
      protocoloComprev: PropTypes.string,
      protocoloTarefaGet: PropTypes.inteiro,
      cpf: PropTypes.string,
      mensagem: PropTypes.string,
      idUo: PropTypes.string,
      idNivel: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

ConsultaOperacoesGet.defaultProps = {
  match: null,
};

export default ConsultaOperacoesGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaOperacoesGet.jsx